import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut } from './utils'

export const getProjectApprovalSummaryForStaff = (id) => {
  const url = `${API_ROOT}/approval/${id}/approve/summary`

  return doGet(url)
}

// ---------------------------------- subproject
export const getProjectApprovalSummaryForStaffSubProject = (projectVersionId, projectCode) => {
  // /api/subproject/{projectVersionId}/approval-summary
  const url = `${API_ROOT}/subproject/approval-summary?projectVersionId=${projectVersionId || ''}&projectCode=${projectCode || ''}`
  return doGet(url)
}

export const saveProjectApprovalSummaryForStaffSubProject = (id, request) => {
  // /api/subproject/{projectVersionId}/approval-summary
  const url = `${API_ROOT}/subproject/${id}/approval-summary`
  return doPost(url, request)
}

// export const updateProjectApprovalSummaryForStaffSubProject = (id, request) => {
//   const url = `${API_ROOT}/subproject/${id}/project-name/${request.id}`
//   return doPut(url, request)
// }
// ----------------------------------
